var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.422,
    height: 26.422,
    viewBox: "0 0 26.422 26.422",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#3fd4a2;}.b{fill:#d9f7ed;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 26.422,
    height: 26.422,
    rx: 5.548
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.124 1.124)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 24.174,
    height: 24.174,
    rx: 4.475
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.2 3.654)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M184.7,230.305h-8.657a2.561,2.561,0,0,1-2.558-2.558V216a2.561,2.561,0,0,1,2.558-2.558H184.7A2.561,2.561,0,0,1,187.258,216v11.75A2.561,2.561,0,0,1,184.7,230.305Zm-8.657-14.617a.31.31,0,0,0-.309.309v11.75a.31.31,0,0,0,.309.309H184.7a.31.31,0,0,0,.309-.309V216a.31.31,0,0,0-.309-.309Z",
    transform: "translate(-173.485 -213.44)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 6.746)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 6.325,
    height: 2.249
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 4.216)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 6.325,
    height: 2.249
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 8.433)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 6.325,
    height: 2.249
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.849 6.746)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 6.325,
    height: 2.249
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 4.216)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 6.325,
    height: 2.249
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 8.433)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 6.325,
    height: 2.249
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinicon);
export default __webpack_public_path__ + "static/media/pinicon.baaf2743bfa26cb5b412af67d2e60b02.svg";
export { ForwardRef as ReactComponent };